import { useIntl } from "react-intl";
import dynamic from "next/dynamic";
import Variables from "../../variables/variables.json";
import SEO from "../../components/SEO";
import Header from "../../components/Header";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import Section from "../Section";

export default function DeklaracjaLayout(props) {
	const intl = useIntl();
	const { miasto, podatek } = props;

	const MdxComponent = dynamic(() =>
		import(
			`../../content/witryna/deklaracja-dostepnosci/${Variables.miasta[miasto].name.url}/deklaracja-dostepnosci_pl.mdx`
		),
	);

	return (
		<>
			<SEO miasto={miasto} podatek={podatek} />
			<Header miasto={miasto} />
			<Breadcrumbs miasto={miasto} layout="light" />
			<Section mdx titleLeft>
				<MdxComponent />
			</Section>
			<Footer miasto={miasto} />
		</>
	);
}
